module.exports = __webpack_public_path__ + "static/media/linha.fe3a2f6f.png";